import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GlobalRespo, GlobalResponseData } from '../../../services/raintree/interfaces/global-respo';
import { MasterSearchTransmissionService } from '../../../services/raintree/Transmission/master-search.service';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { DpLoaderComponent } from '../../../common-component/dp-loader/dp-loader.component';
import { LoaderComponent } from '../../../common-component/loader/loader.component';

@Component({
  selector: 'app-name-search-tab-responsive',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    InfiniteScrollModule,
    DpLoaderComponent,
    LoaderComponent,
  ],
  templateUrl: './name-search-tab-responsive.component.html',
  styleUrl: './name-search-tab-responsive.component.scss'
})
export class NameSearchTabResponsiveComponent {
  responseData: any = [];
  isLoader:boolean = true;
  @Input() data: any;
  @Output() serialNo: EventEmitter<any> = new EventEmitter<any>();
  nameSearchForm = new FormGroup({
    firstName: new FormControl(''),
    lastName: new FormControl({ value: '', disabled: true }),
    guardianFirstName: new FormControl(''),
    guardianLastName: new FormControl({ value: '', disabled: true }),
  });
  pageNo: number=1;
  pageSize: number=200;
  noDataFound: boolean=false;

  constructor(private _masterSearchService: MasterSearchTransmissionService) {

  }

  setupFormListeners() {
    this.nameSearchForm.get('firstName')?.valueChanges.subscribe(value => {
      if (value) {
        this.nameSearchForm.get('lastName')?.enable();
      } else {
        this.nameSearchForm.get('lastName')?.disable();
        this.nameSearchForm.get('lastName')?.reset();
      }
    });

    this.nameSearchForm.get('guardianFirstName')?.valueChanges.subscribe(value => {
      if (value) {
        this.nameSearchForm.get('guardianLastName')?.enable();
      } else {
        this.nameSearchForm.get('guardianLastName')?.disable();
        this.nameSearchForm.get('guardianLastName')?.reset();
      }
    });
  }

  ngOnInit(): void {
    this.setupFormListeners();
  }


  getFormValue(controlName: string): any {
    return this.nameSearchForm.get(controlName)?.value;
  }

  onNameSearch(isStart: boolean) {
    if(isStart){
      this.isLoader=true;
      this.pageNo=1;
      this.responseData=[];
    }
    
    let nameSearchObj = {
      sType: 'EX',
      fName: this.getFormValue('firstName'),
      lname: this.getFormValue('lastName'),
      guardFirstName: this.getFormValue('guardianFirstName'),
      gardLastName: this.getFormValue('guardianLastName'),
      pageNo: 1,
      offSet: 200,
    };

    this._masterSearchService.fetchNameSearchRecords(nameSearchObj).subscribe({
      next: (response: GlobalResponseData) => {
        this.isLoader = false;
        if (response.data.memberList.length == 0) { 
          this.isLoader = false;
          if(isStart){
            this.noDataFound=true;
          }
        }
        else{
          this.responseData = [...this.responseData,...response.data.memberList.map(
            (user: GlobalRespo) => {
              return {
                slNo: user.mk,
                fullName: user.fn + ' ' + user.ln,
                district: user.dn,
                memberStatus: 'FW Pending',
                guardianFullName: user.gfn + ' ' + user.gln,
                initiationDate: user.md,
                ritwik: user.rn,
                pincode: user.pn,
                address: user.add,
              };
            }
          )];
        }
        
      },
      error: (error) => {
        console.log(error);
        this.isLoader=false;
      },
    });
  }

  onScroll(){
    console.log('scroll event occured');
    this.pageNo+=1;
    this.onNameSearch(false);
  }

  onCellClick(event: any) {
    this.serialNo.emit(event);
  }
  
}
